import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

import ListaDe from '../../../components/funcionales/dirmayor/listade';
import ListaCi from '../../../components/funcionales/dirmayor/listaci';
import selciudad from '../../../functions/selciudad';

const DetalleNivel2 = props => {
  return (
    <option>{props.elemento.codigoTipoDoc}</option>
  )
};

const ListaTD = ({handleLista2, list}) => {
  const Nivel2Detalle = list.map((elemento, _id) => <DetalleNivel2 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="tipodoc" id="miLista3" onChange={handleLista2}>
        <option value="">Seleccionar...</option>
        {Nivel2Detalle}
      </select>
    </div>
  )
};

const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.areaAprovech} value={props.elemento._id}>{props.elemento.descrTipoRec}</option>
  )
};

const Lista = ({handleLista2, list}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="tiporec" id="miLista2" onChange={handleLista2}>
        <option value="">Seleccionar...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const AddRec2 = ({styles, list, list1, list2, handleLista2, handleLista3, handleSubmit, codigoCiudadUA, codigoDptoUA,
                  handleLista, handleLista1, modeloFactura, handleChange, args, errors}) => {
  let argsRec = args
  if(!args.dirArchIn){
    argsRec.dirArchIn = ""
  }

  if(codigoCiudadUA!=="Todas..."){
    let dpto = document.getElementById("miLista");
    if(dpto){
      dpto.options.selectedIndex = 0
    }
  }

  let argsSelDpto = {...args}
  argsSelDpto._id = args._idDpto
  let colecc = selciudad(list1, argsSelDpto, codigoCiudadUA)
  let listCiu = colecc.listCiu
// console.log(argsRec)
// console.log(modeloFactura)
  return(
    <div>
      <button className="ui right labeled icon button" style={styles.titBuscar}>
          <i className="large plus yellow icon"></i>
          Recurso nuevo
      </button>
      <div style={styles.box}>
        <Form onSubmit={(ev)=>handleSubmit(ev, argsRec)}>
          <div className="ui one column stackable grid">
            <div className="row container">
              <div className="column" width="100%">
                <Form.Field>
                  <label style={styles.label}>Tipo de documento</label>
                  <ListaTD list={list2} styles={styles} handleLista2={handleLista3} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Número de documento</label>
                  <Form.Input autoComplete="off" name="numeroDocum" id="numeroDocum" onChange={handleChange} placeholder='Número de documento' icon={!errors.length?null: _find(errors, {path:'numeroDocum'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                {/* <Form.Field>
                  <label style={styles.label}>Descripción</label>
                  <Form.Input autoComplete="off" name="descrRecurso" id="descrRecurso" onChange={handleChange} placeholder='Descripción' icon={!errors.length?null: _find(errors, {path:'descrRecurso'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field> */}

                <Form.Field>
                  <div className="ui two column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '50%'}}>
                        <label style={styles.label}>Descripción</label>
                        <Form.Input autoComplete="off" name="descrRecurso" id="descrRecurso" onChange={handleChange} placeholder='Descripción' icon={!errors.length?null: _find(errors, {path:'descrRecurso'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                      </div>
                      <div className="column" style={{width: '50%'}}>
                        <label style={styles.label}>Teléfono de contacto</label>
                        <Form.Input autoComplete="off" name="telContacto" id="telContacto" onChange={handleChange} placeholder='Teléfono de contacto' icon={!errors.length?null: _find(errors, {path:'telContacto'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                      </div>
                    </div>
                  </div>
                </Form.Field>

                <Form.Field>
                  <label style={styles.label}>Tipo de recurso</label>
                  <Lista list={list} styles={styles} handleLista2={handleLista2} />
                </Form.Field>
                <Form.Field>
                  <div className="ui two column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '50%'}}>
                        <label style={styles.label}>Departamento</label>
                        <ListaDe list={list1} styles={styles} handleLista={handleLista}
                          codigoCiudadUA={codigoCiudadUA} codigoDptoUA={codigoDptoUA}/>
                      </div>
                      <div className="column" style={{width: '50%'}}>
                        <label style={styles.label}>Ciudad</label>
                        <ListaCi list={listCiu} styles={styles} handleLista1={handleLista1} args={args}
                          codigoCiudadUA={codigoCiudadUA} codigoDptoUA={codigoDptoUA}/>
                      </div>
                    </div>
                  </div>
                </Form.Field>
                <hr></hr>
                <Form.Field>
                  <label style={styles.label}>Carpeta para recibir archivos de recaudo</label>
                  <Form.Input autoComplete="off" name="dirArchIn" id="dirArchIn" onChange={handleChange} placeholder='Carpeta' icon={!errors.length?null: _find(errors, {path:'dirArchIn'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <hr></hr>
                {modeloFactura==="3" &&
                // {(modeloFactura==="99") &&
                  <div>
                    <label style={styles.label}>{"Estructura archivos de recaudo (dejar en blanco si no tiene el dato o es el dato del final de la línea y es de longitud variable)"}</label>
                    <hr></hr>
                    <Form.Field>
                      <div className="ui twuelve column stackable grid">
                        <div className="row container" style={{paddingBottom: 0}}>
                          <div className="column" style={{width: '10%'}}>
                          </div>
                          <div className="column" style={{width: '8%'}}>
                            <label style={styles.label}>Posic inicial</label>
                          </div>
                          <div className="column" style={{width: '8%'}}>
                            <label style={styles.label}>Longitud</label>
                          </div>
                          <div className="column" style={{width: '7%'}}>
                          </div>
                          <div className="column" style={{width: '8%'}}>
                            <label style={styles.label}>Posic inicial</label>
                          </div>
                          <div className="column" style={{width: '8%'}}>
                            <label style={styles.label}>Longitud</label>
                          </div>
                          <div className="column" style={{width: '8%'}}>
                          </div>
                          <div className="column" style={{width: '8%'}}>
                            <label style={styles.label}>Posic inicial</label>
                          </div>
                          <div className="column" style={{width: '8%'}}>
                            <label style={styles.label}>Longitud</label>
                          </div>
                          <div className="column" style={{width: '7%'}}>
                          </div>
                          <div className="column" style={{width: '8%'}}>
                            <label style={styles.label}>Posic inicial</label>
                          </div>
                          <div className="column" style={{width: '8%'}}>
                            <label style={styles.label}>Longitud</label>
                          </div>
                        </div>
                      </div>
                    </Form.Field>
                    <Form.Field>
                      <div className="ui twuelve column stackable grid">
                        <div className="row container">
                          <div className="column" style={{width: '10%'}}>
                            <label style={styles.label}>Cod Int Ciudad</label>
                          </div>
                          <div className="column" style={{width: '8%'}}>
                            <input type='number' step="1" style={styles.input} autoComplete="off" name="posIniCodCiudad" id="posIniCodCiudad" placeholder='' onChange={handleChange}/>
                          </div>
                          <div className="column" style={{width: '8%'}}>
                            <input type='number' step="1" style={styles.input} autoComplete="off" name="longCodCiudad" id="longCodCiudad" placeholder='' onChange={handleChange}/>
                          </div>
                          <div className="column" style={{width: '7%'}}>
                            <label style={styles.label}>Contrato</label>
                          </div>
                          <div className="column" style={{width: '8%'}}>
                            <input type='number' step="1" style={styles.input} autoComplete="off" name="posIniContrato" id="posIniContrato" placeholder='' onChange={handleChange}/>
                          </div>
                          <div className="column" style={{width: '8%'}}>
                            <input type='number' step="1" style={styles.input} autoComplete="off" name="longContrato" id="longContrato" placeholder='' onChange={handleChange}/>
                          </div>
                          <div className="column" style={{width: '8%'}}>
                            <label style={styles.label}>Doc Identif</label>
                          </div>
                          <div className="column" style={{width: '8%'}}>
                            <input type='number' step="1" style={styles.input} autoComplete="off" name="posIniNumeroDoc" id="posIniNumeroDoc" placeholder='' onChange={handleChange}/>
                          </div>
                          <div className="column" style={{width: '8%'}}>
                            <input type='number' step="1" style={styles.input} autoComplete="off" name="longNumeroDoc" id="longNumeroDoc" placeholder='' onChange={handleChange}/>
                          </div>
                          <div className="column" style={{width: '7%'}}>
                            <label style={styles.label}>Fecha</label>
                          </div>
                          <div className="column" style={{width: '8%'}}>
                            <input type='number' step="1" style={styles.input} autoComplete="off" name="posIniFecha" id="posIniFecha" placeholder='' onChange={handleChange}/>
                          </div>
                          <div className="column" style={{width: '8%'}}>
                            <input type='number' step="1" style={styles.input} autoComplete="off" name="longFecha" id="longFecha" placeholder='' onChange={handleChange}/>
                          </div>
                        </div>
                      </div>
                    </Form.Field>
                    <Form.Field>
                      <div className="ui twuelve column stackable grid">
                        <div className="row container">
                          <div className="column" style={{width: '10%'}}>
                            <label style={styles.label}>Nombre</label>
                          </div>
                          <div className="column" style={{width: '8%'}}>
                            <input type='number' step="1" style={styles.input} autoComplete="off" name="posIniNombre" id="posIniNombre" placeholder='' onChange={handleChange}/>
                          </div>
                          <div className="column" style={{width: '8%'}}>
                            <input type='number' step="1" style={styles.input} autoComplete="off" name="longNombre" id="longNombre" placeholder='' onChange={handleChange}/>
                          </div>
                          <div className="column" style={{width: '7%'}}>
                            <label style={styles.label}>Apellido</label>
                          </div>
                          <div className="column" style={{width: '8%'}}>
                            <input type='number' step="1" style={styles.input} autoComplete="off" name="posIniApellido" id="posIniApellido" placeholder='' onChange={handleChange}/>
                          </div>
                          <div className="column" style={{width: '8%'}}>
                            <input type='number' step="1" style={styles.input} autoComplete="off" name="longApellido" id="longApellido" placeholder='' onChange={handleChange}/>
                          </div>
                          <div className="column" style={{width: '8%'}}>
                            <label style={styles.label}>Valor</label>
                          </div>
                          <div className="column" style={{width: '8%'}}>
                            <input type='number' step="1" style={styles.input} autoComplete="off" name="posIniValor" id="posIniValor" placeholder='' onChange={handleChange}/>
                          </div>
                          <div className="column" style={{width: '8%'}}>
                            <input type='number' step="1" style={styles.input} autoComplete="off" name="longValor" id="longValor" placeholder='' onChange={handleChange}/>
                          </div>
                        </div>
                      </div>
                    </Form.Field>

                    <Form.Field>
                      <div className="ui twuelve column stackable grid">
                        <div className="row container">
                          <div className="column" style={{width: '10%'}}>
                            <label style={styles.label}>EXCLUIR</label>
                          </div>
                          <div className="column" style={{width: '8%'}}>
                            <input type='number' step="1" style={styles.input} autoComplete="off" name="numPrimLinExcluir" id="numPrimLinExcluir" placeholder='' onChange={handleChange}/>
                          </div>
                          <div className="column" style={{width: '40%'}}>
                            <label style={styles.label}>primeras líneas</label>
                          </div>
                        </div>
                      </div>
                    </Form.Field>
                    <hr></hr>
                  </div>
                }

                <Button style={styles.confirmar} type='submit' fluid>
                  AGREGAR
                </Button>

                {
                  errors.length?<Message negative header="Los siguientes errores:"
                  list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default AddRec2
